//老铺黄金

import FloatingPC from '@/rebuild/materials/shared/floating/LaoPuBaseFloatingPC.vue';
import FloatingMobile from '@/rebuild/materials/shared/floating/BaseFloatingMobile.vue';

export const componentMap = {
	basic: FloatingPC,
	'basic-mobile': FloatingMobile
};